module.exports = __webpack_public_path__ + "media/media/home/img10-dc5901cb842245be78313a9883130ec0.png";